import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ensure } from 'components/sharpr/ensure/ensure';

export function IntegrationSlackRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.IntegrationSlack', {
		url: '/admin/integrations/slack',
		controllerAs: 'vm',
		controller: IntegrationSlackCtrl,
		templateUrl: '/ng/hub/Integration/Slack/IntegrationSlackCtrl.html?' + window.BUILD,
		permission: ['manage_hubs'],
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Integration/Slack/IntegrationSlackCtrl.css'),
			$title: () => 'Integrate Slack',
		},
	});
}

export class IntegrationSlackCtrl {
	constructor(Identity, Api, Cfg, $filter, modal, $state) {
		'ngInject';
		// Save injections
		this.Identity = Identity;
		this.Api = Api;
		this.Cfg = Cfg;
		this.shDateFormat = $filter('shDate');
		this.modal = modal;
		this.$state = $state;
		// bind functions
		this.format = this.format.bind(this);
		this.delete = this.delete.bind(this);
		// define table details
		this.columns = [
			{ field: 'slack_team_name', label: 'Slack Team Name', sortable: false },
			{ field: 'created_at', label: 'Date Connected', sortable: false },
			{ field: 'user_id', label: 'Connected By', sortable: false },
		];
		this.actions = [{ label: 'Remove Integration', icon: null, callback: this.delete }];
		this.getSlackAppClientId();
		this.redirectUri = encodeURIComponent(`${window.BASE_URL}/slack/request_slack_token`);
	}

	async getSlackAppClientId() {
		const slackCredentials = await this.Api.get(`/credentials/hub_default?type=slack-app`);
		this.slackAppClientId = slackCredentials.username;
	}

	// Function to format the date correctly and get the right f+lname of the person who set up the integration
	format(result) {
		ensure.array(result.data).forEach(connection => {
			connection.created_at = this.shDateFormat(connection.created_at, 'long');
		});
		return result;
	}

	// Function to remove the integration from the selected workspace
	delete(team) {
		this.modal
			.confirm({
				escapedHtml: `Are you sure you want to remove the Slack Integration from ${_.escape(team.slack_team_name)}?`,
			})
			.then(
				() => {
					this.Api.delete(`/slack/${team.slack_team_id}`).then(() => {
						this.$state.reload();
					});
				},
				() => {}
			);
	}
}
